module.exports = __webpack_public_path__ + "static/media/mail_icon.c2672eef.svg";